<app-enfaf-modal
  svgIcon="users-dark"
  [title]="'STUDENT.COURSE_MATRICULATION.TITLE' | translate: { course: data.name }"
  [buttonCancelText]="'COMMON.CLOSE' | translate"
  [showConfirmButton]="false"
  (onClose)="closeModal()"
>
  <div class="preview-toolbar">
    <enfaf-select
      class="filter-select"
      [control]="filterControl"
      [options]="filterOptions"
      [label]="'STUDENT.COURSE_MATRICULATION.FILTER' | translate"
      name="course-matriculation-filter"
      [withoutHint]="true"
    ></enfaf-select>
    <enfaf-searchable-input
      [control]="searchControl"
      [label]="'COMMON.SEARCH' | translate"
      [placeholder]="'STUDENT.COURSE_MATRICULATION.SEARCH_PLACEHOLDER' | translate"
      name="course-matriculation-search"
      color="light"
    ></enfaf-searchable-input>
  </div>

  @if (isLoading()) {
    <div class="state-message" role="status">
      <span class="loading-indicator" aria-hidden="true"></span>
      <span>{{ 'COMMON.LOADING' | translate }}</span>
    </div>
  } @else if (hasError()) {
    <p class="state-message" role="alert">{{ 'STUDENT.COURSE_MATRICULATION.LOAD_ERROR' | translate }}</p>
  } @else {
    @if (!filteredStudents().length) {
      <div class="empty-state" role="status">
        <div class="placeholder-icon">
          <img src="assets/icon/search-dark.svg" alt="" aria-hidden="true" />
        </div>
        <div class="placeholder-text">
          <span class="main-text">{{ emptyStateMessage() | translate }}</span>
        </div>
      </div>
    } @else {
      <div class="table-wrapper">
        <table>
          <caption class="visually-hidden">{{ 'STUDENT.COURSE_MATRICULATION.TABLE_CAPTION' | translate }}</caption>
          <colgroup>
            <col class="column-student" />
            <col class="column-email" />
            <col class="column-phone" />
            <col class="column-classes" />
            <col class="column-finished" />
            <col class="column-date" />
            <col class="column-options" />
          </colgroup>
          <thead>
            <tr>
              <th scope="col" class="is-left-aligned">{{ 'STUDENT.MATRICULATION.STUDENT' | translate }}</th>
              <th scope="col" class="is-left-aligned">{{ 'STUDENT.MATRICULATION.EMAIL' | translate }}</th>
              <th scope="col">{{ 'STUDENT.MATRICULATION.PHONE' | translate }}</th>
              <th scope="col">{{ 'STUDENT.MATRICULATION.CLASSES' | translate }}</th>
              <th scope="col">{{ 'STUDENT.MATRICULATION.FINISHED' | translate }}</th>
              <th scope="col">{{ 'STUDENT.MATRICULATION.FINISHED_DATE' | translate }}</th>
              <th scope="col">{{ 'STUDENT.MATRICULATION.OPTIONS' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @for (student of pagedStudents(); track student.userId) {
              <tr>
                <td class="is-left-aligned">{{ student.name }} {{ student.lastname }}</td>
                <td class="is-left-aligned">{{ student.email || '-' }}</td>
                <td>{{ student.phone ? (student.phonePrefix || '-') + ' ' + student.phone : '-' }}</td>
                <td>{{ student.totalClasses }}</td>
                <td>
                  @if (student.finished) {
                    <span class="finished-status">
                      <app-enfaf-icon
                        svgIconName="check-circle-blue"
                        iconSize="16px"
                        role="img"
                        [attr.aria-label]="'COMMON.YES' | translate"
                        title="{{ 'COMMON.YES' | translate }}"
                      ></app-enfaf-icon>
                    </span>
                  } @else {
                    {{ 'COMMON.NO' | translate }}
                  }
                </td>
                <td>{{ formatFinishedDate(student.finishedDate) }}</td>
                <td class="options">
                  @if (student.finished) {
                    <app-enfaf-button
                      type="modal-primary"
                      buttonType="button"
                      [isLoading]="downloadingDiplomaUserId() === student.userId"
                      [disabled]="downloadingDiplomaUserId() !== null"
                      (onClick)="downloadDiploma(student.userId)"
                    >
                      <span>{{ 'STUDENT.COURSE_MATRICULATION.DOWNLOAD_DIPLOMA' | translate }}</span>
                    </app-enfaf-button>
                  } @else {
                    <app-enfaf-button
                      type="modal-outline"
                      buttonType="button"
                      [isLoading]="completingUserId() === student.userId"
                      [disabled]="completingUserId() !== null || confirmingUserId() !== null"
                      (onClick)="confirmCourseCompletion(student.userId)"
                    >
                      <span>{{ 'STUDENT.COURSE_MATRICULATION.COMPLETE_COURSE' | translate }}</span>
                    </app-enfaf-button>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      @if (filteredStudents().length > pageSize()) {
        <div class="pagination-container">
          <enfaf-pagination
            [config]="paginationConfig()"
            color="light"
            (pageChange)="onPageChange($event.currentPage)"
            (pageSizeChange)="onPageSizeChange($event)"
          ></enfaf-pagination>
        </div>
      }
    }

    <div class="export-action">
      <app-enfaf-button
        type="upload"
        buttonType="button"
        [isLoading]="isExporting()"
        [disabled]="isExporting() || !students().length"
        [matTooltip]="'STUDENT.COURSE_MATRICULATION.EXPORT_TOOLTIP' | translate"
        matTooltipPosition="below"
        (onClick)="exportExcel()"
        height="54px"
        [setNgStyle]="{ width: 'fit-content', minWidth: 'fit-content' }"
      >
        <img src="assets/icon/cta-upload.svg" alt="" aria-hidden="true" />
        <span>{{ 'STUDENT.COURSE_MATRICULATION.EXPORT_BUTTON' | translate }}</span>
      </app-enfaf-button>
    </div>
  }
</app-enfaf-modal>
